'use client';

import { Box, Typography, Chip } from '@mui/material';

import Link from 'next/link';
import { colorVariables } from '@/constants';
import { Vendor } from '@/lib/types/interfaces/Vendor';

const CategoryLocations = ({ service }: { service: Vendor }) => {
  const [currentCategory] = service.categories;
  const parrentCategoriesIds: { [key: number]: string } = service.categories.reduce(
    (acc, { id, slug }) => ({ ...acc, [id]: slug }),
    {},
  );

  const renderCategoryChip = service.categories?.map((item) => (
    <Link
      key={item.slug}
      href={`/services/${item.slug}`}
      aria-label={`Go to services ${item.slug}`}
      prefetch={false}
    >
      <Chip
        label={item.name}
        key={item.id}
      />
    </Link>
  ));
  const renderSubcategoryChips = service.subcategories?.map((item) => (
    <Link
      key={`${parrentCategoriesIds[item.parent_id]}-${item.slug}`}
      href={`/services/${parrentCategoriesIds[item.parent_id]}/${item.slug}`}
      aria-label={`Go to services ${parrentCategoriesIds[item.parent_id]} ${item.slug}`}
      prefetch={false}
    >
      <Chip
        label={item.name}
        key={item.id}
      />
    </Link>
  ));

  const renderLocationServedChips = service.locations?.map((item) => (
    <Link
      key={`${currentCategory?.slug}-${item.state}-${item.name}`}
      href={`/services/${currentCategory?.slug}/${item.state}/${item.name.replaceAll(' ', '_')}`}
      aria-label={`Go to services ${currentCategory?.slug} ${item.state} ${item.name}`}
      prefetch={false}
    >
      <Chip
        label={`${item.name}, ${item.state}`}
        key={item.id}
      />
    </Link>
  ));

  return (
    <>
      {currentCategory && (
        <Box display={{ xs: 'none', lg: 'block' }}>
          <Typography
            variant='h6'
            component='h5'
            fontWeight={600}
            color={colorVariables.textDescription}
          >
            Category
          </Typography>
          <Box
            display='flex'
            flexWrap='wrap'
            gap={1}
            marginTop={1}
          >
            {renderCategoryChip}
            {renderSubcategoryChips}
          </Box>
        </Box>
      )}

      <Box marginTop={currentCategory ? 3 : 0}>
        <Typography
          variant='h6'
          fontWeight={600}
          color={colorVariables.textDescription}
        >
          Locations Served
        </Typography>
        <Box
          display='flex'
          flexWrap='wrap'
          gap={1}
          marginTop={1}
        >
          {renderLocationServedChips}
        </Box>
      </Box>
    </>
  );
};

export default CategoryLocations;
